<script setup>
import { computed } from 'vue';

import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/companyprofile.svg';

const props = defineProps({
    logoUrl: {
        type: [String, URL],
        required: false,
        default: null,
    },
    size: {
        type: String,
        required: false,
        default: 'md',
        validator: x => ['sm', 'md', 'lg', 'xl'].includes(x),
    },
});

const classes = computed(() => {
    const res = ['company-logo-box'];
    if (props.size !== 'md') {
        res.push('company-logo-box--' + props.size);
    }
    return res;
});
</script>

<template>
    <div
        :class="classes"
        role="presentation"
    >
        <img
            :src="logoUrl"
            alt=""
            class="company-logo-box__logo"
            v-if="logoUrl"
        >
        <div class="company-logo-box__placeholder" v-else>
            <SvgIcon name="companyprofile" :size="size" />
        </div>
    </div>
</template>
